import axios, { AxiosResponse } from 'axios';

export interface BaseSectionProps {
  accountOrig: AccountData;
}
export interface BasicSectionProps extends BaseSectionProps {
  saveAccountInfo: (accountInfo: AccountData) => Promise<AxiosResponse<AccountInfoHTTPResponse>>
}
export interface SectionProps extends BasicSectionProps {
  showEditIcon: boolean;
  setEditing: (flag: boolean) => void;
}

export interface PhoneSectionProps extends BasicSectionProps {
  doCancel: () => void;
  changeMode: (mode: PhoneMode) => void;
}

export interface EmailSectionProps extends BasicSectionProps {
  doCancel: () => void;
  changeMode: (mode: EmailMode, accountResponse?: AccountData | undefined, verifySuccess?: boolean) => void;
}

export interface SignInPayload {
  username: string;
  password: string;
  g_recaptcha_response?: string;
  client_id: string;
}

export interface SignInResponse {
  data: {
    authToken: string;
    socialUser: boolean;
    auoUser: boolean;
    minor: boolean;
  };
}

// TODO: handle reCaptcha
// const { additionalHeaders } = window.appAirDrop.config;
const { config } = window.appAirDrop;
const accountRootURL = config.accountRootUrl;
const clientId = config.CLIENT_ID;
const infoUrl = `${accountRootURL}/account/info?client_id=${clientId}`;
const dataPrivacyTokenUrl = `${accountRootURL}/account/dataprivacytoken`;

export function signin(payload: SignInPayload): Promise<AxiosResponse<SignInResponse>> {
  return axios.post<SignInResponse>(`${accountRootURL}/account/signin`, payload);
}

export function getAccountInfoSvc(authToken: string): Promise<AxiosResponse<AccountInfoHTTPResponse>> {
  return axios.get(infoUrl, {
    headers: {
      'Content-Type': 'application/json',
      'X-Authorization': authToken,
    },
  });
}

export function saveAccountInfoSvc(
  authToken: string,
  payload: AccountData,
)
  : Promise<AxiosResponse<AccountInfoHTTPResponse>> {
  return axios.post(infoUrl, payload, {
    headers: {
      // ...(additionalHeaders ?? {}),
      'Content-Type': 'application/json',
      'X-Authorization': authToken,
    },
  });
}

export function getRightToInfoFileSvc(authToken: string) : Promise<AxiosResponse<DataPrivacyResponse>> {
  // Post with no payload in PIUI
  return axios.post(dataPrivacyTokenUrl, {
    headers: {
      'Content-Type': 'application/json',
      'X-Authorization': authToken,
    },
  });
}
